import { useCallback } from 'react';

import { Path } from 'constants/routing';
import { RootState } from 'store/store';
import { useAppDispatch, useAppStore } from 'store/store-hooks';
import { setSelectedFile } from 'components/app/projects/_mediator/projects.slice';
import { useSelectorCb } from 'components/app/selector/_mediator/use-selector-cb';

export const useMemorySr = () => {
  const { srSelectClip } = useSelectorCb();
  const dispatch = useAppDispatch();
  const store = useAppStore();

  return useCallback(() => {
    const { cameFrom, fcSnapshot, clipsMap } = selectData(store.getState());
    if (cameFrom === Path.finalcuts) {
      if (!fcSnapshot || !fcSnapshot.activeClip) return;
      const clipData = clipsMap && clipsMap[fcSnapshot.activeClip];
      if (clipData) {
        srSelectClip(clipData.clipId);
        dispatch(setSelectedFile(clipData.mediaFileId));
      }
    }
  }, []);
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { cameFrom, finalcut: fcSnapshot } = state.memory;
  const { clipsMap } = state.editor;
  return { cameFrom, clipsMap, fcSnapshot };
};
